import { RootState } from '@/redux/store'

export const selectStore = (state: RootState) => state['@stores'].data

export const selectStoreState = (state: RootState) => state['@stores']
